import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button, ButtonContainer } from 'components/button';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { deleteVideoAction } from 'common/actions';
import { abortUploadAction, uploadResetAction } from 'pages/upload.page/actions';
import { appRoutes } from 'routes';
import { withRouter } from 'react-router-dom';

export const CANCEL_UPLOAD_DIALOG = 'CancelUploadDialog';

export const CancelUploadDialog = withRouter(
  connect(false, (dispatch, props) => ({
    hideDialog: () => dispatch(hideDialogAction(CANCEL_UPLOAD_DIALOG)),
    cancelUpload: () => {
      dispatch(hideDialogAction(CANCEL_UPLOAD_DIALOG));
      dispatch(deleteVideoAction(props.video.id));
      dispatch(abortUploadAction());
      dispatch(uploadResetAction());
      props.history.push(props.isPodcast ? appRoutes.uploadPodcast : appRoutes.upload);
    },
  }))(({ hideDialog, cancelUpload }) => {
    const { t } = useTranslation();
    return (
      <DialogDecorated dialogName={CANCEL_UPLOAD_DIALOG} data-e2e="cancel-upload-dialog">
        <DialogTitle>
          <h2>{t('cancel_upload')}</h2>
        </DialogTitle>
        <DialogBody>
          <div className="ct-stp2-dialog-body">
            <p>{t('cancel_upload_alert')}</p>
            <p>{t('cancel_upload_message')}.</p>
          </div>
        </DialogBody>
        <DialogFooter>
          <ButtonContainer>
            <Button id="dont_cancel_button" onClick={() => hideDialog()} secondary={true}>
              {t('dont_cancel')}
            </Button>
            <Button onClick={() => cancelUpload()}>{t('cancel_upload')}</Button>
          </ButtonContainer>
        </DialogFooter>
      </DialogDecorated>
    );
  })
);

CancelUploadDialog.propTypes = {
  video: PropTypes.object,
};
